export default __webpack_public_path__ + "jpg/7d1d485bfaa47b554a45d3b9636605d5.jpg";